/* One calendar-day policy for product pages and both carts. */
(() => {
  if (customElements.get('orlueur-delivery-window')) return;
  const policy = { minDays: 17, maxDays: 21, timeZone: 'Asia/Shanghai' };
  class DeliveryWindow extends HTMLElement {
    connectedCallback() { this.update(); }
    update() {
      try {
        const parts = new Intl.DateTimeFormat('en-US', {
          timeZone: policy.timeZone, year: 'numeric', month: 'numeric', day: 'numeric'
        }).formatToParts(new Date());
        const part = (type) => Number(parts.find((p) => p.type === type).value);
        const start = new Date(Date.UTC(part('year'), part('month') - 1, part('day')));
        const end = new Date(start);
        start.setUTCDate(start.getUTCDate() + policy.minDays);
        end.setUTCDate(end.getUTCDate() + policy.maxDays);
        const locale = document.documentElement.lang || 'en';
        const sameYear = start.getUTCFullYear() === end.getUTCFullYear();
        const monthDay = new Intl.DateTimeFormat(locale, {
          timeZone: 'UTC', month: 'short', day: 'numeric', ...(sameYear ? {} : { year: 'numeric' })
        });
        const dayOnly = new Intl.DateTimeFormat(locale, { timeZone: 'UTC', day: 'numeric' });
        const sameMonth = sameYear && start.getUTCMonth() === end.getUTCMonth();
        const text = `${monthDay.format(start)}–${(sameMonth ? dayOnly : monthDay).format(end)}`;
        const strong = this.querySelector('strong');
        if (strong && strong.textContent !== text) strong.textContent = text;
      } catch (_) { /* Keep the readable 17–21 day fallback if Intl is unavailable. */ }
    }
  }
  customElements.define('orlueur-delivery-window', DeliveryWindow);
  const refresh = () => document.querySelectorAll('orlueur-delivery-window').forEach((el) => el.update());
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  window.addEventListener('pageshow', refresh);
  // Refresh tabs left open across midnight; connectedCallback handles AJAX insertions.
  window.setInterval(() => { if (!document.hidden) refresh(); }, 60000);
})();
